import Vue from 'vue'
import { parseJwt } from '@/utils/Misc'
// 判断用户是否登录
Vue.prototype.$isLogin = function () {
  const jwt = parseJwt(this.$cookies.get('yf_jwt'))
  return jwt && jwt.userId > 0
}
